// ----------------------------------------------------------------------
const account = {
  // displayName: localStorage.getItem('userName'),
  // email: localStorage.getItem('userEmail'),
  photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
